import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

import Logo from '../../images/Horizontal-Logo-white.png'

const ContactPage = () => {
    const SITE_URL = 'https://pharmacyfreedomfund.com';
    const schema = [
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
                { "@type": "ListItem", "position": 2, "name": "Contact Us", "item": `${SITE_URL}/contact-us` }
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Us",
            "url": `${SITE_URL}/contact-us`,
            "mainEntity": {
                "@type": "Organization",
                "name": "Pharmacy Freedom Fund",
                "url": SITE_URL,
                "email": "info@pharmacyfreedomfund.com",
                "telephone": "+1-908-616-2889",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "555 NJ-18",
                    "addressLocality": "East Brunswick",
                    "addressRegion": "NJ",
                    "postalCode": "08816",
                    "addressCountry": "US"
                },
                "logo": `${SITE_URL}/Logo-freedom-color-white-bg.png`,
                "sameAs": []
            }
        }
    ];
    return (
        <Fragment>
            <SEO
                title="Contact Us"
                description="Schedule a consultation with Pharmacy Freedom Fund. Connect with our team to explore investment or pharmacy support opportunities."
                keywords={["contact Pharmacy Freedom Fund", "schedule consultation", "pharmacy funding contact", "investor inquiry"]}
                canonical="https://pharmacyfreedomfund.com/contact-us"
                schema={schema}
            />
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={'Schedule a Consultation'} pagesub={'Contact Us'} />
            <Contactpage />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

